import React from 'react'

import { } from 'react-router-dom';


import Navbar from './Navbar';
import style from './Workout.module.css'
import Category from './Category';
const Workout = () => {
  
  return (
    <>
<Navbar/>
   <div className={style.hero_section}>
          <h2 className={style.hero_title}>Push harder today to become unstoppable tomorrow.</h2>
          <p className={style.hero_text}>
            Transformation doesn’t happen overnight, but every rep, every step, every challenge conquered brings you closer to the unstoppable you
          </p>
        </div>
  
      <Category/>
            
       
</>
  )
}

export default Workout